import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { gate } from 'hub-http/gates';
import { useIsUngated } from '../../../hooks/useIsUngated';
import { jsx as _jsx } from "react/jsx-runtime";
const ALLOWED_PAYMENT_METHOD_TYPES = new Set(['ach', 'card']);
const MaybeSeeFeesActionButton = ({
  transactionFees,
  paymentMethodType,
  paymentCreationMethod,
  processorType,
  openModal
}) => {
  const isUngatedForExpandedMultiCurrency = useIsUngated(gate('Commerce:ExpandedMulticurrency'));
  const hasFees = transactionFees.platformFees.length > 0 || transactionFees.processingFees.length > 0;
  if (!isUngatedForExpandedMultiCurrency || !hasFees || paymentCreationMethod !== 'PAYMENTS_PROCESSOR' || processorType !== 'hs_payments' || !paymentMethodType || !ALLOWED_PAYMENT_METHOD_TYPES.has(paymentMethodType)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, {
    onClick: openModal,
    "data-test-id": "payment-sidebar-actions--see-applied-fees",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.seeAppliedFeesLabel"
    })
  });
};
export default MaybeSeeFeesActionButton;